// hooks/useRechercheCompte.js
import { rxdApi } from 'actions/rtkquery';
import { INITIALISER_RAG_API_ROUTE, RECHERCHE_COMPTE_API_ROUTE, SUGGESTIONS_INTELLIGENTES_API_ROUTE } from 'routes/api/endpoints';

/**
 * API endpoints pour la recherche de comptes comptables via RAG
 * Utilise RTK Query au lieu de React Query
 */
export const rechercheCompteApi = rxdApi.injectEndpoints({
  endpoints: (builder) => ({
    // Initialiser le service RAG
    initialiserRAG: builder.mutation({
      query: () => ({
        url: INITIALISER_RAG_API_ROUTE,
        method: 'POST',
      }),
    }),

    // Rechercher un compte comptable
    rechercherCompte: builder.mutation({
      query: ({ description, top_k = 5, seuil_confiance = 0.1 }) => ({
        url: RECHERCHE_COMPTE_API_ROUTE,
        method: 'POST',
        body: {
          description,
          top_k,
          seuil_confiance,
        },
      }),
    }),

    // Suggestions intelligentes basées sur l'historique
    suggestionsIntelligentes: builder.mutation({
      query: ({ description, dossier_id, top_k = 3 }) => ({
        url: SUGGESTIONS_INTELLIGENTES_API_ROUTE,
        method: 'POST',
        body: {
          description,
          dossier_id,
          top_k,
        },
      }),
    }),

    // Recherche par catégorie
    rechercherParCategorie: builder.mutation({
      query: ({ categorie, top_k = 10 }) => ({
        url: '/api/comptable/rechercher-categorie/',
        method: 'POST',
        body: {
          categorie,
          top_k,
        },
      }),
    }),

    // Obtenir le statut du service
    statutRAG: builder.query({
      query: () => '/api/comptable/statut/',
    }),
  }),
  overrideExisting: false,
});

// Exporter les hooks générés automatiquement
export const {
  useInitialiserRAGMutation,
  useRechercherCompteMutation,
  useRechercherParCategorieMutation,
  useSuggestionsIntelligentesMutation,
  useStatutRAGQuery,
} = rechercheCompteApi;